// src/utils/request.js
import axios from 'axios'
import { ElMessage } from 'element-plus'
import { useAuthStore } from '../stores/auth'
import configManager from './config'

// 使用动态配置的 API 基础地址
const api = axios.create({
  baseURL: configManager.get('API_BASE_URL'),
  timeout: configManager.get('UPLOAD_TIMEOUT', 30000),
})

// 请求拦截器
api.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    const token = authStore.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  (response) => {
    // 如果是 blob 类型，直接返回 response
    // if (response.config.responseType === 'blob') {
    //   console.log('blob response:', response)
    //   return response
    // }
    return response.data
  },
  (error) => {
    // 处理 blob 响应错误
    if (error.config?.responseType === 'blob' && error.response) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.onload = () => {
          try {
            const errorData = JSON.parse(reader.result)
            ElMessage.error(errorData.detail || '下载失败')
          } catch (e) {
            ElMessage.error('下载失败')
          }
          reject(error)
        }
        reader.readAsText(error.response.data)
      })
    }
    
    // 其他错误处理
    if (error.code === 'ECONNABORTED') {
      ElMessage.error('请求超时，请检查网络连接')
    } else if (error.response?.status === 401) {
      const authStore = useAuthStore()
      authStore.logout()
      window.location.href = '/login'
      ElMessage.error('登录已过期，请重新登录')
    } else if (error.response?.status === 403) {
      ElMessage.error('权限不足')
    } else if (error.response?.status === 404) {
      ElMessage.error('请求的资源不存在')
    } else if (error.response?.status === 500) {
      ElMessage.error('服务器内部错误')
    } else if (error.response?.data?.detail) {
      ElMessage.error(error.response.data.detail)
    } else if (error.message) {
      ElMessage.error(error.message)
    } else {
      ElMessage.error('请求失败')
    }
    return Promise.reject(error)
  }
)

// 添加配置重新加载方法
api.reloadConfig = async () => {
  await configManager.reload()
  api.defaults.baseURL = configManager.get('API_BASE_URL')
  api.defaults.timeout = configManager.get('UPLOAD_TIMEOUT', 30000)
}

export { api, configManager }